import Banner1 from "../Assets/Images/banner1.jpg";
import Banner2 from "../Assets/Images/banner2.jpg";
import Banner3 from "../Assets/Images/banner3.jpg";
import Banner4 from "../Assets/Images/banner4.jpg";
import Banner5 from "../Assets/Images/banner5.jpg";
import Banner7 from "../Assets/Images/banner7.jpg";

const CarouselImages = [
  {
    title: "Congregrant",
    content: "L",
    backgroundImage: Banner4,
  },
  {
    title: "Congregation",
    content: "",
    backgroundImage: Banner2
  },
  {
    title: "Campus-meeting",
    content: "",
    backgroundImage: Banner5,
  },
  {
    title: "Congregation",
    content: "",
    backgroundImage: Banner3,
  },
  {
    title: "Congregation",
    content: "",
    backgroundImage: Banner7,
  },
  {
    title: "Congregation",
    content: "",
    backgroundImage: Banner1,
  },
];

export default CarouselImages;